import {
  invokeServiceWorkerUpdateFlow,
  updateServiceWorker,
} from "./services/skipWatting"
const swDev = async () => {

  let swUrl = `${process.env.PUBLIC_URL}/sw.js`

  if ('serviceWorker' in navigator) {
    console.log('register serviceWorker')

    const registration = await navigator.serviceWorker.register(swUrl)
      .catch(error => {
        console.error('Service worker registration failed:', error)
      })

    if (registration.waiting) {
      invokeServiceWorkerUpdateFlow(registration)
    }else{
      localStorage.setItem('updateServiceWorker',false)
    }
    updateServiceWorker(registration,true)
  }
}

export default swDev